// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__RiKUL {
  text-align: center;
  color: var(--dylo-muted);
  font-size: 12.5px;
  padding: 6px 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".footer {\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 12.5px;\n  padding: 6px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__RiKUL`
};
export default ___CSS_LOADER_EXPORT___;
